<div class="chart-title">
  <span>{{ chartName === '' ? '' : 'Grouped By ' + chartName }}</span>
</div>
<div class="chart-container">
  <div [chart]="chart"></div>
</div>
